// extracted by mini-css-extract-plugin
export default {"LocSubscribersField":"flPF9jTwFyxzkWGxdueht","addRow":"_1H4IkYcrLuw5fN2QBDMIYj"};